import { createSelector } from '@reduxjs/toolkit';

import { B2BTeamState, name } from '../reducers/b2bTeam';

export const getB2BTeamSlice = (state): B2BTeamState => state[name];

export const b2bTeamMembersSelector = createSelector(
  [getB2BTeamSlice],
  ({ members }) => members
);

export const b2bTeamFiltersSelector = createSelector(
  [getB2BTeamSlice],
  ({ filters }) => filters
);

export const filteredB2BTeamMembersSelector = createSelector(
  [b2bTeamMembersSelector, b2bTeamFiltersSelector],
  (members, filters) => {
    const normalizedQuery = filters.query.trim().toLowerCase();

    if (!normalizedQuery) return members;

    return members.filter((member) =>
      [member.fullName, member.email, member.phone]
        .join(' ')
        .toLowerCase()
        .includes(normalizedQuery)
    );
  }
);

export const activeB2BTeamMemberIdSelector = createSelector(
  [getB2BTeamSlice],
  ({ activeMemberId }) => activeMemberId
);

export const activeB2BTeamMemberSelector = createSelector(
  [getB2BTeamSlice],
  ({ activeMember }) => activeMember
);

export const activeB2BTeamMembersCountSelector = createSelector(
  [b2bTeamMembersSelector],
  (members) => members.filter(({ status }) => status === 'active').length
);

export const isB2BTeamLoadingSelector = createSelector(
  [getB2BTeamSlice],
  ({ isLoading }) => isLoading
);

export const isB2BActiveTeamMemberLoadingSelector = createSelector(
  [getB2BTeamSlice],
  ({ isLoadingActiveMember }) => isLoadingActiveMember
);

export const isB2BTeamSavingSelector = createSelector(
  [getB2BTeamSlice],
  ({ isSaving }) => isSaving
);

export const deletingB2BTeamMemberIdSelector = createSelector(
  [getB2BTeamSlice],
  ({ deletingMemberId }) => deletingMemberId
);
